var generic = generic || {};

Drupal.behaviors.avedaPromoFormV1 = {
  attach: function (context) {
    var $avedaPromoForm = $('form#avedaPromoForm', context);
    var $thankyouContent = $('.js-thankyou-text', context);
    var $avedaPromoFormContainer = $('.js-signup-container', context);

    $avedaPromoForm.on('submit', function (event) {
      event.preventDefault();
      // Put the form values into an object
      var paramArr = $avedaPromoForm.serializeArray();
      var paramObj = {};

      $.each(paramArr, function (index, param) {
        paramObj[param.name] = param.value;
      });
      generic.jsonrpc.fetch({
        method: 'rpc.form',
        params: [paramObj],
        onSuccess: function () {
          var redirect_value = $("input[name*='SUCCESS_URL']").val();

          if (redirect_value) {
            window.location.replace(redirect_value);
          } else {
            $avedaPromoFormContainer.toggle();
            $thankyouContent.toggle();
          }
        },
        onFailure: function (jsonRpcResponse) {
          var errorObjectsArray = jsonRpcResponse.getMessages();
          var $ulNode = $('ul.js-error-messages');

          generic.showErrors(errorObjectsArray, $ulNode, $avedaPromoForm);
        }
      });
    });
  }
};
